export default __webpack_public_path__ + "static/wide-silhouette-4f115a72e82d34023391cf51b41b1a9c.png";